module.exports = __webpack_public_path__ + "img/Cluster.6f75e9df.svg";